import { z } from 'zod/v4'
import { zDayJs } from '@/lib/schema/v2/dayjs'

export const permissionSchema = z.object({
    created_at: zDayJs.nullish(),
    name: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
})

export const permissionsSchema = z.array(permissionSchema)

export type Permission = z.infer<typeof permissionSchema>
export type Permissions = z.infer<typeof permissionsSchema>
